import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit{
  title = 'HRMS';
  favIcon: HTMLLinkElement = document.querySelector('#appIcon');
  checkUrl : String;
  constructor() {}

  ngOnInit() {
    this.checkUrl = window.location.href;
    if(this.checkUrl.includes('enrichr'))
    {
      this.favIcon.href = 'assets/images/enrichr_logo_con.ico';
    }
    else
    {
      this.favIcon.href = 'assets/images/favicon.ico';
    }
  }

}
